import { ColumnDefinition } from '../../../../../../generic/universal-table/types/column.types'
import { PackageUiRow } from '../types/packageTable.types'

export const packageTableColumns: ColumnDefinition<PackageUiRow>[] = [
  {
    key: 'PackID',
    title: 'מזהה',
    dataType: 'number',
    width: '70px',
    sortable: true,
    editable: false,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Pack_Name',
    title: 'שם אריזה',
    dataType: 'string',
    width: '180px',
    sortable: true,
    editable: true,
    visible: true,
    required: true,
    cellRendererType: 'text',
  },
  {
    key: 'SupplierID',
    title: 'ספק',
    dataType: 'number',
    width: '200px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Pack_Type',
    title: 'סוג אריזה',
    dataType: 'string',
    width: '140px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Catalog_Number',
    title: 'מספר קטלוגי',
    dataType: 'string',
    width: '130px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Pack_Size',
    title: 'גודל',
    dataType: 'string',
    width: '110px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Pack_Price',
    title: 'מחיר',
    dataType: 'float',
    width: '90px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Tare_Weight',
    title: 'משקל טרה',
    dataType: 'float',
    width: '50px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Qty4Pallets',
    title: 'כמות למשטח',
    dataType: 'number',
    width: '110px',
    sortable: false,
    editable: true,
    visible: true,
    cellRendererType: 'text',
  },
  {
    key: 'Main_PackID',
    title: 'אריזה ראשית',
    dataType: 'number',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Eng_Desc',
    title: 'תיאור אנגלית',
    dataType: 'string',
    width: '160px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Export_Weight',
    title: 'משקל יצוא',
    dataType: 'float',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Volume',
    title: 'נפח',
    dataType: 'float',
    width: '90px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Cooling_Fee',
    title: 'דמי קירור',
    dataType: 'float',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Credit_Fee',
    title: 'דמי אשראי',
    dataType: 'float',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Usage_Fee',
    title: 'דמי שימוש',
    dataType: 'float',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'text',
  },
  {
    key: 'Active',
    title: 'פעיל',
    dataType: 'boolean',
    width: '70px',
    sortable: true,
    editable: true,
    visible: true,
    cellRendererType: 'checkbox',
    align: 'center',
  },
  {
    key: 'DepositWithVAT',
    title: 'פיקדון כולל מעמ',
    dataType: 'boolean',
    width: '130px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Download_from_Warehouse',
    title: 'פריקה ממחסן',
    dataType: 'boolean',
    width: '120px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Inventory',
    title: 'מלאי',
    dataType: 'boolean',
    width: '90px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Providence',
    title: 'השגחה',
    dataType: 'boolean',
    width: '90px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
  {
    key: 'Tranzit_Fee',
    title: 'דמי מעבר',
    dataType: 'boolean',
    width: '100px',
    sortable: false,
    editable: true,
    visible: false,
    cellRendererType: 'checkbox',
  },
]
